/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "گزشتہ کل",
        "-2": "گزشتہ پرسوں",
        "0": "آج",
        "1": "آئندہ کل",
        "2": "آنے والا پرسوں",
        "future": {
          "one": "{0} دن میں",
          "other": "{0} دنوں میں"
        },
        "past": {
          "one": "{0} دن پہلے",
          "other": "{0} دنوں پہلے"
        }
      },
      "day-narrow": {
        "-1": "گزشتہ کل",
        "-2": "گزشتہ پرسوں",
        "0": "آج",
        "1": "آئندہ کل",
        "2": "آنے والا پرسوں",
        "future": {
          "one": "{0} دن میں",
          "other": "{0} دنوں میں"
        },
        "past": {
          "one": "{0} دن قبل",
          "other": "{0} دن قبل"
        }
      },
      "day-short": {
        "-1": "گزشتہ کل",
        "-2": "گزشتہ پرسوں",
        "0": "آج",
        "1": "آئندہ کل",
        "2": "آنے والا پرسوں",
        "future": {
          "one": "{0} دنوں میں",
          "other": "{0} دنوں میں"
        },
        "past": {
          "one": "{0} دن پہلے",
          "other": "{0} دن پہلے"
        }
      },
      "hour": {
        "0": "اس گھنٹے",
        "future": {
          "one": "{0} گھنٹے میں",
          "other": "{0} گھنٹے میں"
        },
        "past": {
          "one": "{0} گھنٹہ پہلے",
          "other": "{0} گھنٹے پہلے"
        }
      },
      "hour-narrow": {
        "0": "اس گھنٹے",
        "future": {
          "one": "{0} گھنٹے میں",
          "other": "{0} گھنٹوں میں"
        },
        "past": {
          "one": "{0} گھنٹہ قبل",
          "other": "{0} گھنٹے قبل"
        }
      },
      "hour-short": {
        "0": "اس گھنٹے",
        "future": {
          "one": "{0} گھنٹے میں",
          "other": "{0} گھنٹے میں"
        },
        "past": {
          "one": "{0} گھنٹے قبل",
          "other": "{0} گھنٹے قبل"
        }
      },
      "minute": {
        "0": "اس منٹ",
        "future": {
          "one": "{0} منٹ میں",
          "other": "{0} منٹ میں"
        },
        "past": {
          "one": "{0} منٹ قبل",
          "other": "{0} منٹ قبل"
        }
      },
      "minute-narrow": {
        "0": "اس منٹ",
        "future": {
          "one": "{0} منٹ میں",
          "other": "{0} منٹ میں"
        },
        "past": {
          "one": "{0} منٹ قبل",
          "other": "{0} منٹ قبل"
        }
      },
      "minute-short": {
        "0": "اس منٹ",
        "future": {
          "one": "{0} منٹ میں",
          "other": "{0} منٹ میں"
        },
        "past": {
          "one": "{0} منٹ قبل",
          "other": "{0} منٹ قبل"
        }
      },
      "month": {
        "-1": "گزشتہ ماہ",
        "0": "اس ماہ",
        "1": "اگلے ماہ",
        "future": {
          "one": "{0} ماہ میں",
          "other": "{0} ماہ میں"
        },
        "past": {
          "one": "{0} ماہ قبل",
          "other": "{0} ماہ قبل"
        }
      },
      "month-narrow": {
        "-1": "گزشتہ ماہ",
        "0": "اس ماہ",
        "1": "اگلے ماہ",
        "future": {
          "one": "{0} ماہ میں",
          "other": "{0} ماہ میں"
        },
        "past": {
          "one": "{0} ماہ قبل",
          "other": "{0} ماہ قبل"
        }
      },
      "month-short": {
        "-1": "پچھلے مہینہ",
        "0": "اس مہینہ",
        "1": "اگلے مہینہ",
        "future": {
          "one": "{0} ماہ میں",
          "other": "{0} ماہ میں"
        },
        "past": {
          "one": "{0} ماہ قبل",
          "other": "{0} ماہ قبل"
        }
      },
      "nu": ["arabext"],
      "quarter": {
        "-1": "گزشتہ سہ ماہی",
        "0": "اس سہ ماہی",
        "1": "اگلے سہ ماہی",
        "future": {
          "one": "{0} سہ ماہی میں",
          "other": "{0} سہ ماہی میں"
        },
        "past": {
          "one": "{0} سہ ماہی پہلے",
          "other": "{0} سہ ماہی پہلے"
        }
      },
      "quarter-narrow": {
        "-1": "گزشتہ سہ ماہی",
        "0": "اس سہ ماہی",
        "1": "اگلے سہ ماہی",
        "future": {
          "one": "{0} سہ ماہی میں",
          "other": "{0} سہ ماہی میں"
        },
        "past": {
          "one": "{0} سہ ماہی پہلے",
          "other": "{0} سہ ماہی پہلے"
        }
      },
      "quarter-short": {
        "-1": "گزشتہ سہ ماہی",
        "0": "اس سہ ماہی",
        "1": "اگلے سہ ماہی",
        "future": {
          "one": "{0} سہ ماہی میں",
          "other": "{0} سہ ماہی میں"
        },
        "past": {
          "one": "{0} سہ ماہی قبل",
          "other": "{0} سہ ماہی قبل"
        }
      },
      "second": {
        "0": "اب",
        "future": {
          "one": "{0} سیکنڈ میں",
          "other": "{0} سیکنڈ میں"
        },
        "past": {
          "one": "{0} سیکنڈ قبل",
          "other": "{0} سیکنڈ قبل"
        }
      },
      "second-narrow": {
        "0": "اب",
        "future": {
          "one": "{0} سیکنڈ میں",
          "other": "{0} سیکنڈ میں"
        },
        "past": {
          "one": "{0} سیکنڈ قبل",
          "other": "{0} سیکنڈ قبل"
        }
      },
      "second-short": {
        "0": "اب",
        "future": {
          "one": "{0} سیکنڈ میں",
          "other": "{0} سیکنڈ میں"
        },
        "past": {
          "one": "{0} سیکنڈ قبل",
          "other": "{0} سیکنڈ قبل"
        }
      },
      "week": {
        "-1": "گزشتہ ہفتہ",
        "0": "اس ہفتہ",
        "1": "اگلے ہفتہ",
        "future": {
          "one": "{0} ہفتہ میں",
          "other": "{0} ہفتوں میں"
        },
        "past": {
          "one": "{0} ہفتہ قبل",
          "other": "{0} ہفتے قبل"
        }
      },
      "week-narrow": {
        "-1": "پچھلے ہفتہ",
        "0": "اس ہفتہ",
        "1": "اگلے ہفتہ",
        "future": {
          "one": "{0} ہفتہ میں",
          "other": "{0} ہفتے میں"
        },
        "past": {
          "one": "{0} ہفتہ قبل",
          "other": "{0} ہفتے قبل"
        }
      },
      "week-short": {
        "-1": "پچھلے ہفتہ",
        "0": "اس ہفتہ",
        "1": "اگلے ہفتہ",
        "future": {
          "one": "{0} ہفتے میں",
          "other": "{0} ہفتے میں"
        },
        "past": {
          "one": "{0} ہفتے قبل",
          "other": "{0} ہفتے قبل"
        }
      },
      "year": {
        "-1": "گزشتہ سال",
        "0": "اس سال",
        "1": "اگلے سال",
        "future": {
          "one": "{0} سال میں",
          "other": "{0} سالوں میں"
        },
        "past": {
          "one": "{0} سال پہلے",
          "other": "{0} سال پہلے"
        }
      },
      "year-narrow": {
        "-1": "گزشتہ سال",
        "0": "اس سال",
        "1": "اگلے سال",
        "future": {
          "one": "{0} سال میں",
          "other": "{0} سال میں"
        },
        "past": {
          "one": "{0} سال پہلے",
          "other": "{0} سال پہلے"
        }
      },
      "year-short": {
        "-1": "گزشتہ سال",
        "0": "اس سال",
        "1": "اگلے سال",
        "future": {
          "one": "{0} سال میں",
          "other": "{0} سالوں میں"
        },
        "past": {
          "one": "{0} سال پہلے",
          "other": "{0} سالوں پہلے"
        }
      }
    },
    "locale": "ur-IN"
  });
}